import { lazy } from 'react';
const EmpWrkStation = lazy(() => import('./EmpWrkStation'));

const EmpWrkStationRoutes = [
  {
    path: '/hrsystem/empwrkstation',
    component: EmpWrkStation
  }
];

export default EmpWrkStationRoutes;
